<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">FAQ Sections/Headers</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createFAQSection">Create New Section</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="faqsections.columns" :data="faqsections.data">
                    <template slot="table-row" v-if="faqsections.data.length">
                        <tr v-for="(item, index) in faqsections.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.faqHeader}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewFAQSection(item)" v-tooltip.top-center="faqsections.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editFAQSection(item)" v-tooltip.top-center="faqsections.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const faqsectionsColumns = ['Section Header','Status', 'Operations'];
    export default {
        name: 'FAQSections',
        components: {
            LTable,
        },
        data() {
        return {
              faqsections: {
                tooltips: {
                    view: 'View FAQ Section',
                    edit: 'Edit FAQ Section',
                    delete: 'Inactivate FAQ Section',
                    activate:'Activate FAQ Section',
                },
                columns: [...faqsectionsColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchFAQSections () {
            this.$store.dispatch('FETCH_FAQSECTIONS')
                    .then((res) => {
                        this.faqsections.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewFAQSection(faqHeader){
            this.$router.push({ name: 'FAQSectionDetail', params: { id: faqHeader.faqHeaderId}})
        },
        editFAQSection(faqHeader){
            this.$router.push({ name: 'EditFAQSection', params: { id: faqHeader.faqHeaderId}})
        },
        createFAQSection(){
            this.$router.push({ name: 'CreateFAQSection'})
        },
    },
    created() {
        this.fetchFAQSections();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FAQSect/FAQSections.vue